function formatPrice(price) {  
  if(price == undefined)
    return "$0";
  price = parseFloat(price).toFixed(2);
  return "$"+(new Intl.NumberFormat('es-AR', {})).format(price)
}

function formatNumber(number) {  
  if(number == undefined)
    return "0";
  number = parseFloat(number).toFixed(2);
  return (new Intl.NumberFormat('es-AR', {})).format(number)
}

function formatPriceNumber(price) {  
  return parseFloat(parseFloat(price).toFixed(2));  
}

function formatDateString(date_string) {
  //Format "yyyy-mm-dd" to "dd/mm/yyyy"
  if(date_string === null) return "-";
  
  const [year, month, day] = date_string.split('-');
  
  const dayFormatted = day.padStart(2, '0');
  const monthFormatted = month.padStart(2, '0');
  
  return `${dayFormatted}/${monthFormatted}/${year}`;  
}

/*
Si el comprobante no es en mon_id PES, entonces se convierte el valora mostrar segun mon_cotiz
*/
function formatValueByCurrency(value, comprobante) {  
  console.log("formatValueByCurrency", value, comprobante);
  if(comprobante.mon_id === "PES") {
    return value;
  } else {
    return parseFloat(parseFloat(value / comprobante.mon_cotiz).toFixed(2));
  }
}

export const formatUtils = {
  formatPrice,  
  formatNumber,
  formatPriceNumber,
  formatDateString,
  formatValueByCurrency
};
